var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { USERDATA_FAILED, USERDATA_RECEIVED } from './userdata-action';
import { APPS_NAV_DATA_REQUESTED, OWNER_SELECTED_BY_ID } from "./apps-nav-action";
import { USER_LOGGED_OUT } from "./auths-action";

var initialState = {
    loginUrl: '/login',
    logoutUrl: '/logout',
    apps: [],
    owners: [],
    ownerUniqueId: null,
    preSelectedOwner: null,
    isFetching: false,
    selectedOwner: null
};

var userReducer = function userReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case APPS_NAV_DATA_REQUESTED:
            return _extends({}, state, {
                isFetching: true
            });
        case USERDATA_RECEIVED:
            return _extends({}, state, action.userdata, {
                apps: action.apps,
                owners: action.museums,
                isFetching: false,
                ownerUniqueId: state.preSelectedOwner,
                selectedOwner: action.museums.find(function (owner) {
                    return owner.uniqueId === state.preSelectedOwner;
                })
            });
        case OWNER_SELECTED_BY_ID:
            if (state.owners.length) {
                return _extends({}, state, {
                    ownerUniqueId: action.ownerId.toString(),
                    selectedOwner: state.owners.find(function (owner) {
                        return owner.uniqueId === action.ownerId.toString();
                    })
                });
            } else {
                return _extends({}, state, {
                    preSelectedOwner: action.ownerId.toString()
                });
            }
        case USERDATA_FAILED:
            return _extends({}, state, {
                isFetching: false
            });
        case USER_LOGGED_OUT:
            return initialState;
        default:
            return state;
    }
};

export default userReducer;